import { Step, StepProps } from '../../components';
import { FORM_FIELDS } from '../../components/OnboardingForm';

type Props = Omit<StepProps, 'heading' | 'subheading' | 'name' | 'percentage'>;

const OnboardingRecipientContainer = (props: Props) => {
  return (
    <Step
      {...props}
      heading="Who is the card for?"
      subheading="This is the name that will appear in the card header"
      name={FORM_FIELDS.RECIPIENT_NAME.name}
      percentage={25}
    />
  );
};

OnboardingRecipientContainer.displayName = 'OnboardingRecipientContainer';

export default OnboardingRecipientContainer;
